import { ExpandableListItem } from '@trr/internaltypes'
import { Helmet } from 'react-helmet-async'

interface FAQSchemaProps {
  listItems: { properties: ExpandableListItem }[]
}

const FAQSchema = ({ listItems }: FAQSchemaProps) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: listItems.map((item) => ({
      '@type': 'Question',
      name: item.properties.heading,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.properties.body,
      },
    })),
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  )
}

export default FAQSchema
